"use client";

import { SlimBanner as SlimBannerComponent } from "@pamperedchef/design-system";

export interface SlimBannerBlockProps {
	texts: string[];
}

/**
 * Slim banner block component
 */
export function SlimBannerBlock({ texts }: SlimBannerBlockProps): JSX.Element {
	return <SlimBannerComponent texts={texts} />;
}
